var React = require('react');

function CloseX (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M7.22748 7.22711C7.52038 6.93421 7.99525 6.93421 8.28814 7.22711L16.7734 15.7124C17.0663 16.0053 17.0663 16.4802 16.7734 16.773C16.4805 17.0659 16.0057 17.0659 15.7128 16.773L7.22748 8.28777C6.93459 7.99487 6.93459 7.52 7.22748 7.22711Z","fill":"#212529","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M16.7725 7.22711C17.0654 7.52 17.0654 7.99487 16.7725 8.28777L8.28724 16.773C7.99434 17.0659 7.51947 17.0659 7.22658 16.773C6.93368 16.4802 6.93368 16.0053 7.22658 15.7124L15.7119 7.22711C16.0048 6.93421 16.4796 6.93421 16.7725 7.22711Z","fill":"#212529","key":1})]);
}

CloseX.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CloseX;

CloseX.default = CloseX;
